import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user-check",
  "use": "icon-user-check-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-user-check\">\n  <path d=\"M304 352c79.5 0 144 64.5 144 144s-64.5 144-144 144-144-64.5-144-144 64.5-144 144-144z m0 224c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80z\" fill=\"currentColor\" p-id=\"14427\" />\n  <path d=\"M218.4 768.1C240.4 750.1 267.4 740 296 740h16c28.6 0 55.6 10.1 77.6 28.1 23.8 19.4 37.4 48.7 37.4 80.4V904c0 4.4-3.6 8-8 8H140c-4.4 0-8-3.6-8-8v-55.5c0-31.7 13.6-61 37.4-80.4z\" fill=\"currentColor\" p-id=\"14428\" />\n  <path d=\"M912.7 299.1l-253.9 253.9c-3.1 3.1-8.2 3.1-11.3 0L543.8 449.3c-3.1-3.1-8.2-3.1-11.3 0l-42.4 42.4c-3.1 3.1-3.1 8.2 0 11.3l146.2 146.2c3.1 3.1 8.2 3.1 11.3 0l338.6-338.6c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4c-3.1-3.1-8.2-3.1-11.3 0z\" fill=\"currentColor\" p-id=\"14429\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/user-check.svg
// module id = vd3+
// module chunks = 117